export const SESSION_REFRESH_INTERVAL = 10; // minutes

export const AUTH_ERROR_QUERY_STRING_KEY = "message";

export const CREATIVES_MEDIA_DOMAIN = "https://km-adexpress.kantarmedia.fr";

export const LANGUAGES = {
  en: "en",
  fr: "fr",
};

export const ROLES = {
  admin: "Administrator",
  operator: "Operator",
};

export const DATA_SOURCE = {
  pathmatics: "Pathmatics",
  bis: "BIS",
  eRetail: "ERetail",
  ctv: "CTV",
};

export const EXCLUDED_NUMERIC_FIELD_CHARS = [",", ".", "-", "+", "e", "E"];

export const NUMERIC_INPUT_LIMIT = 300;

export const MENU_SECTIONS = {
  pathmatics: "pathmatics",
  bis: "bis",
  selfPromotion: "self-promotion",
  allMapping: "all-mappings",
  audience: "audience",
  eRetail: "e-retail",
  ctv: "ctv",
};

export const MAPPING_FILTER_DATEPICKER_START_DATE = {
  default: "2023-01-01",
  facebook: "2019-01-01",
};

export const MAPPING_KEYS_DATE_FORMAT = "DD/MM/YYYY";
export const MAPPING_KEYS_API_DATE_FORMAT = "YYYY-MM-DD";

export const TABLE_ROWS_PER_PAGE = [25, 50, 75, 100];

// Table page number must be a zero-based index value
export const DEFAULT_TABLE_PAGINATION = {
  pageNumber: 0,
  pageSize: TABLE_ROWS_PER_PAGE[0],
};

// mapping keys date filters
export const START_DATE = "startDate";
export const END_DATE = "endDate";

export const DEFAULT_MAPPING_KEYS_FILTERS = {
  [START_DATE]: null,
  [END_DATE]: null,
  mediaChannelIds: [],
  mappingStatus: "",
  threshold: "None",
  socialAccountName: "",
  socialAccountFriendlyName: "",
  productId: "",
  productLabel: "",
  advertiserId: "",
  advertiserLabel: "",
};

export const DEFAULT_MAPPING_KEYS_SORTING = {
  sortOption: {
    sortColumn: "SocialAccountName",
    direction: "asc",
  },
};

// Payload page number must be a one-based index value
export const DEFAULT_MAPPING_KEYS_PAYLOAD = {
  ...DEFAULT_TABLE_PAGINATION,
  pageNumber: 1,
  ...DEFAULT_MAPPING_KEYS_FILTERS,
  ...DEFAULT_MAPPING_KEYS_SORTING,
};

export const DEFAULT_MAPPING_KEYS_EXPORT_PAYLOAD = {
  ...DEFAULT_MAPPING_KEYS_FILTERS,
  ...DEFAULT_MAPPING_KEYS_SORTING,
  userLanguage: "fr",
};

export const MEDIA_CHANNELS = {
  facebook: "Facebook",
  instagram: "Instagram",
  snapchat: "Snapchat",
  tiktok: "TikTok",
  linkedin: "LinkedIn",
};

// default time after lines are automatically unlocked
export const DEFAULT_COUNTDOWN_TIMER = 30 * 60;
export const DEFAULT_COUNTDOWN_INTERVAL = 1000; // ex: 1000 (1s), 500 (ms), etc...

export const SEARCH_FIELD_MIN_CHARS = 3;

export const ADVERTISER_ID = "advertiserId";
export const ADVERTISER_LABEL = "advertiserLabel";
export const PRODUCT_ID = "productId";
export const SOURCE_PRODUCT_ID = "sourceProductId";
export const PRODUCT_LABEL = "productLabel";

export const DEFAULT_PRODUCT_LISTING_FILTERS = {
  [ADVERTISER_ID]: "",
  [ADVERTISER_LABEL]: "",
  [SOURCE_PRODUCT_ID]: "",
  [PRODUCT_LABEL]: "",
  includeSocialAccounts: false,
  sortOption: {
    sortColumn: "ProductName",
    direction: "asc",
  },
};

export const DEFAULT_PATHMATICS_PRODUCT_LISTING_FILTERS = {
  [ADVERTISER_ID]: "",
  [ADVERTISER_LABEL]: "",
  [SOURCE_PRODUCT_ID]: "",
  [PRODUCT_LABEL]: "",
  includeSocialAccounts: true,
};

export const ACTIVATION_FILTER_OPTIONS = {
  default: "Default",
  creatives: "Creatives",
  bisCampaigns: "BisCampaigns",
  selfPromotion: "SelfPromotion",
};

export const MAPPING_OPTIONS = {
  bis: "BisCampaign",
  bisCreative: "BisCreative",
  pathmatics: "SocialAccount",
  pathmaticsCreative: "SocialAccountCreative",
  eRetailCreative: "ERetailCreative",
  ctvCreative: "CtvCreative",
};

export const MAPPING_KEYS_STATUSES = {
  validated: "Validated",
  rejected: "Rejected",
  reject: "Reject",
  auto: "Auto",
  manual: "Manual",
  manualDomainMapped: "M/Domain Mapped",
  autoDomainMapped: "A/Domain Mapped",
  waitingProductRequested: "Waiting, product requested",
  waitingProductCreated: "Waiting, product created",
  notMapped: "Not mapped",
};

export const DEFAULT_POOL_SIZES_ARRAY = [10, 50, 100];

export const DEFAULT_POOL_SIZE_PAYLOAD = {
  currentPoolSize: 10,
  previousPoolSize: 10,
  productId: null,
  nextPool: false,
};

export const DEFAULT_BIS_MAPPING_KEYS_FILTERS = {
  [START_DATE]: null,
  [END_DATE]: null,
  status: "",
  keywordSearchField: "all",
  keyword: "",
};

export const DEFAULT_BIS_MAPPING_KEYS_SORTING = {
  sortOption: {
    sortColumn: "FirstOccurrence",
    direction: "asc",
  },
};

export const DEFAULT_BIS_MAPPING_KEYS_PAYLOAD = {
  ...DEFAULT_TABLE_PAGINATION,
  pageNumber: 1,
  ...DEFAULT_BIS_MAPPING_KEYS_FILTERS,
};

export const DEFAULT_BIS_MAPPING_KEYS_EXPORT_PAYLOAD = {
  ...DEFAULT_BIS_MAPPING_KEYS_FILTERS,
  ...DEFAULT_BIS_MAPPING_KEYS_SORTING,
  userLanguage: "fr",
};

export const DEFAULT_CREATIVE_REVIEW_FILTERS = {
  creativeId: "",
  creativeHashCode: "",
  product: "",
  advertiser: "",
  startDate: null,
  endDate: null,
  status: "",
};

export const DEFAULT_CREATIVE_REVIEW_EXPORT_PAYLOAD = {
  ...DEFAULT_CREATIVE_REVIEW_FILTERS,
  userLanguage: "fr",
};

export const DEFAULT_CREATIVE_REVIEW_SORTING = {
  sortOption: {
    sortColumn: "",
    direction: "asc",
  },
};

export const DEFAULT_CREATIVE_REVIEW_CONTEXT = {
  useValidVisual: () => ({
    isLoading: null,
    setValidVisual: null,
  }),
  useMappingKeyStatus: () => ({
    isLoading: null,
    paperClipMappingKey: null,
    rejectMappingKey: null,
    validateMappingKey: null,
  }),
};

export const DEFAULT_MONITORING_FILTERS = {
  view: "media",
  unit: "Occurrences",
  devices: ["Desktop"],
  period: "Day",
  startDate: null,
  endDate: null,
  advertiserLabel: "",
};

export const DEFAULT_MONITORING_MEDIA_SORTING = {
  sortOption: {
    sortColumn: "Media",
    direction: "asc",
  },
};

export const DEFAULT_MONITORING_ADVERTISER_SORTING = {
  sortOption: {
    sortColumn: "Advertiser",
    direction: "asc",
  },
};

export const DEFAULT_MONITORING_MEDIA_PAYLOAD = {
  pagination: {
    ...DEFAULT_TABLE_PAGINATION,
    pageNumber: 1,
  },
  unit: DEFAULT_MONITORING_FILTERS.unit,
  devices: DEFAULT_MONITORING_FILTERS.devices,
  period: DEFAULT_MONITORING_FILTERS.period,
  startDate: DEFAULT_MONITORING_FILTERS.startDate,
  endDate: DEFAULT_MONITORING_FILTERS.endDate,
  ...DEFAULT_MONITORING_MEDIA_SORTING,
  userLanguage: "",
};

export const DEFAULT_MONITORING_ADVERTISER_PAYLOAD = {
  pagination: {
    ...DEFAULT_TABLE_PAGINATION,
    pageNumber: 1,
  },
  unit: DEFAULT_MONITORING_FILTERS.unit,
  devices: DEFAULT_MONITORING_FILTERS.devices,
  period: DEFAULT_MONITORING_FILTERS.period,
  startDate: DEFAULT_MONITORING_FILTERS.startDate,
  endDate: DEFAULT_MONITORING_FILTERS.endDate,
  advertiserLabel: DEFAULT_MONITORING_FILTERS.advertiserLabel,
  ...DEFAULT_MONITORING_ADVERTISER_SORTING,
  userLanguage: "",
};

export const DEFAULT_MAPPINGS_VIEW_FILTERS = {
  mediaType: "",
  category: "",
  media: "",
  advertiser: "",
  product: "",
};

export const DEFAULT_MAPPINGS_VIEW_SORTING = {
  sortOption: {
    sortColumn: "Media",
    direction: "asc",
  },
};

export const DEFAULT_MAPPINGS_VIEW_PAYLOAD = {
  ...DEFAULT_TABLE_PAGINATION,
  pageNumber: 1,
  ...DEFAULT_MAPPINGS_VIEW_FILTERS,
  ...DEFAULT_MAPPINGS_VIEW_SORTING,
};

export const PREDEFINED_FILTER = {
  selfPromotion: "self-promotion",
};

export const DEFAULT_MEDIA_LISTING_FILTERS = {
  mediaId: "",
  mediaLabel: "",
};

export const DEFAULT_ADVERTISER_LISTING_FILTERS = {
  advertiserId: "",
  advertiserLabel: "",
};

export const DEFAULT_SELF_PROMOTION_PRODUCT_LISTING_FILTERS = {
  [ADVERTISER_ID]: "",
  [ADVERTISER_LABEL]: "",
  [SOURCE_PRODUCT_ID]: "",
  [PRODUCT_LABEL]: "",
  includeSocialAccounts: false,
  sortOption: {
    sortColumn: "ProductName",
    direction: "asc",
  },
};

export const DEFAULT_ALL_MAPPINGS_VIEW_FILTERS = {
  mediaId: "",
  mediaLabel: "",
  DataProvider: "",
  DisplayMediaType: "",
  bisId: "",
  bisLabel: "",
};

export const DEFAULT_ALL_MEDIA_VIEW_PAYLOAD = {
  ...DEFAULT_TABLE_PAGINATION,
  pageNumber: 1,
  ...DEFAULT_ALL_MAPPINGS_VIEW_FILTERS,
};

export const DEFAULT_ALL_MEDIA_SORTING = {
  sortOption: {
    sortColumn: "mediaid",
    direction: "asc",
  },
};

export const DEFAULT_BIS_FILTERS = {
  idbis: "",
  libellebis: "",
};

export const FRONTEND_TO_BACKEND_SORT_MAP = {
  mediaId: "mediaid",
  mediaName: "medialabel",
  dataProviderName: "dataprovidername",
  displayTypeName: "displaytype",
  mappingCount: "numberofmappings",
};

export const BACKEND_TO_FRONTEND_SORT_MAP = Object.fromEntries(
  Object.entries(FRONTEND_TO_BACKEND_SORT_MAP).map(([front, back]) => [
    back,
    front,
  ]),
);

export const AUDIENCE_DISPLAY_TYPES = [
  { id: "77875e4d-8a75-4481-ba9a-2a29832a7840", name: "Mobile" },
  { id: "5e4c0316-b883-4d3c-89a6-ca712dba65de", name: "Desktop" },
  { id: "3e3447e2-11f0-4d55-b74f-258ff224c9dd", name: "Youtube Desktop" },
  { id: "5b9ebf30-832e-457a-814d-b744e93a48c9", name: "Youtube Mobile" },
  { id: "4c8984b5-d9a0-424f-ab77-437976c56fcb", name: "Application" },
];

export const AUDIENCE_MAPPING_STATUSES = [
  { value: "all", label: "All" },
  { value: "notMapped", label: "Not mapped" },
  { value: "validated", label: "Validated" },
  { value: "rejected", label: "Rejected" },
];

export const DEFAULT_E_RETAIL_DATA_ASSIGNMENT_FILTERS = {
  status: "",
  advertiserPaid: "",
  advertiserName: "",
  [START_DATE]: null,
  [END_DATE]: null,
};

export const DEFAULT_E_RETAIL_DATA_ASSIGNMENT_EXCLUSIONS = {
  advertiserExclusion: {
    advertiserExclusionNames: [],
    includeAll: false,
  },
};

export const DEFAULT_E_RETAIL_DATA_ASSIGNMENT_SORTING = {
  sortOption: {
    sortColumn: "FirstOccurrence",
    direction: "asc",
  },
};

export const DEFAULT_E_RETAIL_DATA_ASSIGNMENT_PAYLOAD = {
  ...DEFAULT_TABLE_PAGINATION,
  pageNumber: 1,
  ...DEFAULT_E_RETAIL_DATA_ASSIGNMENT_FILTERS,
  ...DEFAULT_E_RETAIL_DATA_ASSIGNMENT_EXCLUSIONS,
  ...DEFAULT_E_RETAIL_DATA_ASSIGNMENT_SORTING,
};

export const DEFAULT_E_RETAIL_DATA_ASSIGNMENT_EXPORT_PAYLOAD = {
  ...DEFAULT_E_RETAIL_DATA_ASSIGNMENT_FILTERS,
  ...DEFAULT_E_RETAIL_DATA_ASSIGNMENT_EXCLUSIONS,
  ...DEFAULT_E_RETAIL_DATA_ASSIGNMENT_SORTING,
  userLanguage: "fr",
};

export const BUYERS_STATUSES = {
  brand: "Brand",
  reseller: "Reseller",
  exclude: "Exclude",
  notMapped: "Not mapped",
};

export const DEFAULT_E_RETAIL_CREATIVE_REVIEW_FILTERS = {
  creativeId: "",
  product: "",
  advertiser: "",
  advertiserName: "",
  advertiserPaid: "",
  startDate: null,
  endDate: null,
  keyword: "",
  status: "",
};

export const DEFAULT_E_RETAIL_CREATIVE_REVIEW_EXPORT_PAYLOAD = {
  ...DEFAULT_E_RETAIL_CREATIVE_REVIEW_FILTERS,
  userLanguage: "fr",
};

export const DEFAULT_CREATIVE_ANALYSIS_SORTING = {
  sortOption: {
    sortColumn: "CreativesCount",
    direction: "asc",
  },
};

export const DEFAULT_E_RETAIL_CREATIVE_ANALYSIS_FILTERS = {
  idSearchField: "CreativeId",
  idKeyword: "",
  taxonomySearchField: "Product",
  taxonomyKeyword: "",
  startDate: null,
  endDate: null,
  advertiserName: "",
  advertiserPaid: "",
  keyword: "",
  sponsorType: "All",
  statuses: [],
  groupByColumns: [],
};

export const DEFAULT_E_RETAIL_CREATIVE_ANALYSIS_FILTERS_PAYLOAD = {
  ...DEFAULT_TABLE_PAGINATION,
  pageNumber: 1,
  ...DEFAULT_E_RETAIL_CREATIVE_ANALYSIS_FILTERS,
  ...DEFAULT_CREATIVE_ANALYSIS_SORTING,
};

export const DEFAULT_E_RETAIL_CREATIVE_ANALYSIS_EXPORT_PAYLOAD = {
  ...DEFAULT_E_RETAIL_CREATIVE_ANALYSIS_FILTERS,
  ...DEFAULT_CREATIVE_ANALYSIS_SORTING,
  userLanguage: "fr",
};

export const DEFAULT_CREATIVE_ANALYSIS_COLUMNS = [
  "creativeId",
  "asin",
  "product",
  "productId",
  "advertiser",
  "advertiserId",
  "advertiserName",
  "advertiserPaid",
  "keyword",
  "sponsorType",
  "status",
];

export const E_RETAIL_SPENDS_AUTOREFRESH_INTERVAL = 60; // seconds

export const E_RETAIL_SPEND_STATUS_TYPES = {
  inProgress: 1,
  finished: 2,
  error: 3,
};

export const E_RETAIL_SPEND_STATUSES = {
  [E_RETAIL_SPEND_STATUS_TYPES.inProgress]: "warning",
  [E_RETAIL_SPEND_STATUS_TYPES.finished]: "success",
  [E_RETAIL_SPEND_STATUS_TYPES.error]: "error",
};

export const E_RETAIL_SPEND_MESSAGE_TYPES = {
  // 1: "info",
  2: "warning",
  3: "error",
};

export const DEFAULT_E_RETAIL_SPENDS_COMPUTE_OPTIONS = {
  reloadData: false,
  includeExtraData: false,
};
